import _objectSpread from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["component", "mask", "replacement", "showMask", "separate", "modify", "onMask"];
import { jsx as e } from "react/jsx-runtime";
import { forwardRef as o } from "react";
import { useConnectedInputRef as r } from "@react-input/core";
import t from "./useMask.js";
var a = o(function (_ref, f) {
  var o = _ref.component,
    a = _ref.mask,
    s = _ref.replacement,
    m = _ref.showMask,
    n = _ref.separate,
    p = _ref.modify,
    c = _ref.onMask,
    i = _objectWithoutProperties(_ref, _excluded);
  var k = t({
      mask: a,
      replacement: s,
      showMask: m,
      separate: n,
      modify: p,
      onMask: c
    }),
    u = r(k, f);
  return e(o || "input", _objectSpread({
    ref: u
  }, i));
});
export { a as default };